import Vue from 'vue'
import Vuex from 'vuex'
import {firebase, db, auth} from '@/fb'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    
    menu: {
      user: [
        { icon: 'dashboard', text: 'Dashboard', path:'/' },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Whatsapp',
          model: false,
          children: [
            { icon: 'send', text: 'Whatsapp Chat', path:'/wa-chat' },
            //{ icon: 'people', text: 'Bulk Whatsapp', path:'/data' },
          ]
        },
      ],
      ///////// CENTER MENU /////////////
      admin:[
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Leads',
          model: false,
          children: [
            { icon: 'dashboard', text: 'Dashboard', path:'/' },
            { icon: 'fiber_new', text: 'New Leads', path:'/?filter=new' },
            { icon: 'fiber_new', text: 'New Leads Today', path:'/?filter=newToday' },
            { icon: 'update', text: 'Updated Today', path:'/?filter=today' },
            { icon: 'videocam', text: 'Interviews', path:'/?filter=interviews' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Registrations',
          model: false,
          children: [
            { icon: 'dashboard', text: 'Registrations', path:'/registrations' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Providers & Applications',
          model: false,
          children: [
            {
              icon: 'dashboard',
              text: 'Dashboard',
              path: '/providers-dashboard'
            },
          ]
        },
        // {
        //   icon: 'keyboard_arrow_up',
        //   'icon-alt': 'keyboard_arrow_down',
        //   text: 'Imports',
        //   model: false,
        //   children: [
        //     { icon: 'cloud_upload', text: 'Import Orders', path:'/import-orders' },
        //     { icon: 'cloud_upload', text: 'Import Products', path:'/import-products' },
        //     { icon: 'cloud_upload', text: 'Import Cities', path:'/import-cities' },
        //   ]
        // },
        // {
        //   icon: 'keyboard_arrow_up',
        //   'icon-alt': 'keyboard_arrow_down',
        //   text: 'Whatsapp',
        //   model: false,
        //   children: [
        //     { icon: 'send', text: 'Whatsapp Chat', path:'/wa-chat' },
        //     { icon: 'cloud_upload', text: 'Import Data', path:'/import-data' },
        //     { icon: 'people', text: 'Bulk Whatsapp Data', path:'/data' },
        //     { icon: 'people', text: 'Whatsapp Campaigns', path:'/wa-campaigns' },
        //   ]
        // },
        
      ],
      admins: [
        { icon: 'dashboard', text: 'Dashboard', path:'/' },
        { icon: 'work', text: 'Account', path:'/' },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Data',
          model: false,
          children: [
            { icon: 'import_export', text: 'Import Data', path:'/import-data' },
            { icon: 'people', text: 'Data', path:'/data' },

          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Whatsapp',
          model: false,
          children: [
            { icon: 'send', text: 'Whatsapp Chat', path:'/wa-chat' },
            { icon: 'people', text: 'Bulk Whatsapp', path:'/wa-mass' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Email',
          model: false,
          children: [
            { icon: 'send', text: 'Email Templates', path:'/email-templates' },
            { icon: 'people', text: 'Bulk Emails', path:'/email-mass' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'SMS',
          model: false,
          children: [
            { icon: 'send', text: 'SMS Templates', path:'/sms-templates' },
            { icon: 'people', text: 'Bulk SMSs', path:'/sms-mass' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Shortlinks',
          model: false,
          children: [
            { icon: 'link', text: 'Generate', path:'/shortlink' },
            { icon: 'assignment', text: 'Report', path:'/shortlinks' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Instagram',
          model: false,
          children: [
            { icon: 'link', text: 'Single Post', path:'/instagram-post' },
          ]
        },
        { icon: 'aspect_ratio', text: 'Landing Page Generator', path:'/landing-page-generator' },
        { icon: 'settings', text: 'Settings', path:'/settings' },
      ],
    },
    role:null,
    user:null,
    candidates:[],
    centerData:null,
    userData:null,
    tokens:null
  },
  getters: {
    
  },
  mutations: {
      
  },
  actions: {
    
  },
})